import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loading: HTMLIonLoadingElement | undefined;

  constructor(
    private readonly loadingCtrl: LoadingController,
    private readonly translateService: TranslateService
  ) {}

  async presentLoading({
    labelToTranslate = 'LOADING.TITLE',
    forceClose = false,
  }: { labelToTranslate?: string; forceClose?: boolean } = {}): Promise<void> {
    if (forceClose) {
      await this.dismissLoading();
    }
    if (!this.loading) {
      let translatedLabel: string;
      try {
        translatedLabel = await this.translateService.get(labelToTranslate).toPromise();
      } catch (error) {}
      this.loading = await this.loadingCtrl.create({ message: translatedLabel ?? 'Caricamento in corso...' });
      this.loading.present();
    }
  }

  async dismissLoading(): Promise<void> {
    await this.loading?.dismiss();
    this.loading = undefined;
  }
}
